import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from './context/AuthContext';
import Layout from './components/layout/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Kiosk from './pages/Kiosk';
import EmployeePortal from './pages/EmployeePortal';
import Schedule from './pages/Schedule';
import Employees from './pages/Employees';
import Payroll from './pages/Payroll';
import Locations from './pages/Locations';
import TimeEntries from './pages/TimeEntries';
import AuditLog from './pages/AuditLog';
import MySchedule from './pages/MySchedule';
import MyHoursEmployee from './pages/MyHoursEmployee';
import MyPayroll from './pages/MyPayroll';
import UserManagement from './pages/UserManagement';
import TimeOffRequests from './pages/TimeOffRequests';
import Messages from './pages/Messages';
import Help from './pages/Help';
import Reports from './pages/Reports';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/clock" element={<Kiosk />} />
          <Route path="/employee" element={<EmployeePortal />} />
          
          {/* Protected Routes */}
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            
            {/* Admin & Manager Routes */}
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="schedule" element={<Schedule />} />
            <Route path="time-entries" element={<TimeEntries />} />
            <Route path="employees" element={<Employees />} />
            <Route path="payroll" element={<Payroll />} />
            <Route path="locations" element={<Locations />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="audit-log" element={<AuditLog />} />
            <Route path="time-off" element={<TimeOffRequests />} />
            <Route path="messages" element={<Messages />} />
            <Route path="reports" element={<Reports />} />
            <Route path="help" element={<Help />} />
            
            {/* Employee Routes */}
            <Route path="my-schedule" element={<MySchedule />} />
            <Route path="my-hours" element={<MyHoursEmployee />} />
            <Route path="my-payroll" element={<MyPayroll />} />
            <Route path="my-time-off" element={<TimeOffRequests />} />
            <Route path="my-messages" element={<Messages />} />
          </Route>
          
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
